import { apiUrls } from 'consts'
import { setMessage } from 'redux/actions'
import Store from 'redux/Store'
import { axiosPost } from 'shared/api/axios'
import displayGenError from 'shared/utils/displayGenError'

interface handleFilterSaveProps {
  data: any
  setShowOverlay: Function
  setIsSaveFiltersRequestLoading: Function
}

const handleFiltersSave = async (props: handleFilterSaveProps) => {
  props.setIsSaveFiltersRequestLoading(true)
  let response: any = false

  const formData = {
    ...props.data,
  }

  response = await axiosPost(
    apiUrls.filters + '/' + apiUrls.actionSaveFilter,
    formData,
    () => displayGenError({ setShowOverlay: props.setShowOverlay }),
    props.setIsSaveFiltersRequestLoading(false),
  ).then((res) => {
    if (res!.status === 200) {
      Store.dispatch(setMessage('Filters successfully saved', 'success', 'instant'))
    }
  })

  props.setIsSaveFiltersRequestLoading(false)
  return response
}

export default handleFiltersSave
